export default "__VITE_ASSET__Bq5NKLzh__"